export enum GoalType {
  Coaching = 'Coaching',
  Observations = 'Observations',
  Celebrations = 'Celebrations',
  GrowthRate = 'Growth Rate',
  SkillsAttained = 'Skills Attained',
}
